import ReportsList from '@/components/reports/ReportsList'
import ReportsNew from '@/components/reports/ReportsNew'
import ReportEdit from '@/components/reports/ReportEdit'

export default [
  {
    path: '/reports',
    name: 'reports',
    component: ReportsList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reports/new',
    name: 'reportsNew',
    component: ReportsNew,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reports/:id/edit',
    name: 'reportEdit',
    component: ReportEdit,
    meta: {
      requiresAuth: true
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/reportsRoutes.js